/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown> }} Portals_Bump_TitleInputs */

const cs_portals_bump_title = /** @type {(inputs: Portals_Bump_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bump — ${i?.provider}`)
};

const en_portals_bump_title = /** @type {(inputs: Portals_Bump_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bump — ${i?.provider}`)
};

/**
* | output |
* | --- |
* | "Bump — {provider}" |
*
* @param {Portals_Bump_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_bump_title = /** @type {((inputs: Portals_Bump_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Bump_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_bump_title(inputs)
	return cs_portals_bump_title(inputs)
});